import { observer } from "mobx-react-lite";
import styles from "./commissionTablesSection.module.scss";
import { CommissionSystem } from "view360Card/models";
import { constants } from "shared/constants";
import { CommissionsTableEhm, CommissionsTableEhz, ShowableComponent } from "..";
import React from "react";

export interface CommissionTablesSectionProps {
    commissionSystemList: CommissionSystem[];
}

export const CommissionTablesSection: React.FC<CommissionTablesSectionProps> = observer((props) => {
    return (
        <>
            {props.commissionSystemList.map((commissionSystem) => {
                let node: React.ReactNode = null;
                if (
                    commissionSystem.code === constants.systems.ehm.ihestia ||
                    commissionSystem.code === constants.systems.ehm.jupiter
                ) {
                    node = (
                        <CommissionsTableEhm
                            key={`CommissionsTableEhm-${commissionSystem.id}`}
                            commissionLines={commissionSystem.lineList ?? []}
                        />
                    );
                } else {
                    node = (
                        <CommissionsTableEhz
                            systemId={commissionSystem.id}
                            key={`CommissionsTableEhz-${commissionSystem.id}`}
                            commissionLines={commissionSystem.lineList ?? []}
                        />
                    );
                }
                return (
                    <div key={`showableComponentContainer-${commissionSystem.id}`} className={styles.itemContainer}>
                        <ShowableComponent
                            key={`showableComponent-${commissionSystem.id}`}
                            node={node}
                            title={commissionSystem.description}
                        />
                    </div>
                );
            })}
        </>
    );
});
